/**
 * Drop provenance blobs from section HTML before it is posted to
 * `POST /ara/render`.
 *
 * The generation pipeline embeds per-section
 * `<script type="application/json" data-prov-index="...">…</script>` indexes
 * (tool calls, args, event URLs) so the dev-mode "Display Sources" feature can
 * trace figures back to their data. Those blobs only matter inside the apps/ara
 * static client — web-v2 never reads them — and their inline `<script>` +
 * mass-JSON signature is what the WAF blocks with a 403 on `/ara/render`.
 *
 * The render response itself never re-embeds them: `_render` only wraps
 * whatever `body_html` it receives, so stripping here removes them from the
 * preview document for good.
 */
export function stripAraProvenance(html: string): string {
  return html.replace(
    /<script\b[^>]*\bdata-prov-index(?:="[^"]*")?[^>]*>[\s\S]*?<\/script>/gi,
    ''
  )
}
